export default __webpack_public_path__ + "static/media/jarry nadler.08882aff.jpg";